import { useIntl, defineMessages } from 'react-intl';
import { useLocation } from 'react-router-dom';

import { RichTextArticle } from 'design-comuni-plone-theme/components/ItaliaTheme/View';

import FolderCard from '../Common/FolderCard';

const PersonaProduzioneScientifica = () => {
  const intl = useIntl();
  const location = useLocation();
  const path = location.pathname;

  return (
    <RichTextArticle
      title={intl.formatMessage(messages.produzione_scientifica)}
      tag_id="produzione_scientifica"
    >
      <div className="container">
        <div className="row">
          <FolderCard
            url={`${path}/produzione-scientifica`}
            title={intl.formatMessage(messages.produzione_scientifica)}
          />
        </div>
      </div>
    </RichTextArticle>
  );
};

const messages = defineMessages({
  produzione_scientifica: {
    id: 'produzione_scientifica',
    defaultMessage: 'Produzione scientifica',
  },
});

export default PersonaProduzioneScientifica;
